import React from "react";
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { RxLink2 } from 'react-icons/rx';

import AnimateOnView from './AnimateOnView';
import Empresas from "./Empresas";

function resolveProjectLink(link, language) {
    if (link === 'internal:ecommerce') {
        return `${process.env.PUBLIC_URL}/${language}/ecommerce`;
    }

    return link;
}

export default function Projects({ projects = [] }) {

    const { t, i18n } = useTranslation();

    const currentLanguage = i18n.language;

    const projectsLog = projects.map((project) => ({
        ...project,
        ttl: t(project.titleKey),
        desc: t(project.descriptionKey),
        link: resolveProjectLink(project.link, currentLanguage),
    }));
    // const isExternalLink = (url) => url.startsWith('http');
    return (
        <section className="portfolio-section portfolio-section-projects" id="proyectos">
            <div className="container">

                    <h2 className="portfolio-section__title">
                        {t('ttlProjects')}
                        <span></span>
                    </h2>

                    <p className="portfolio-section__text col-12 col-md-8 text-center mx-auto">
                        {t('descriptionProjects')}
                    </p>

                    <Empresas />

                    <div className="row">
                        {
                            projectsLog.map((item, idx) => {
                                // stagger within each row (2 columns) so simultaneous cards animate slightly offset
                                const perRowIndex = idx % 2; // 0 or 1 for two-column layout
                                const delay = perRowIndex * 0.12

                                return (
                                    <AnimateOnView
                                        key={`${item.img}-${item.ttl}`}
                                        className="col-12 col-md-6 col-xl-6 projects__col"
                                        variants={{
                                            hidden: { opacity: 0, y: 40 },
                                            visible: { opacity: 1, y: 0 }
                                        }}
                                        delay={delay}
                                    >

                                        <div className="project-card">

                                            <div className="project-card__image-container">

                                                <img
                                                    className="project-card__image-container__image object-fit-contain img-fluid"
                                                    src={`${process.env.PUBLIC_URL}/img/portfolio/${item.img}.png`}
                                                    alt={item.ttl}
                                                />

                                            </div>

                                            <div className="project-card__caption">

                                                <a
                                                    href={item.link}
                                                    target={item.link.startsWith('http') ? '_blank' : '_self'}
                                                    rel={item.link.startsWith('http') ? 'noopener noreferrer' : ''}
                                                    className="project-card__link"
                                                >

                                                    <span>
                                                        <RxLink2 />
                                                        <RxLink2 className="invisible" />
                                                    </span>

                                                    <span>{item.ttl}</span>

                                                </a>

                                                <p className="project-card__description">
                                                    {item.desc}
                                                </p>

                                                <div className="row project-card__tags">

                                                    {
                                                        item.tools.map((data) => (

                                                            <div
                                                                key={data}
                                                                className="col-6 col-sm-6 col-lg-6 col-xxl-4"
                                                            >

                                                                <span
                                                                    className={`project-card__tag--${data.toLowerCase().trim().replace(/\s+/g, '')} project-card__tag`}
                                                                >
                                                                    {data}
                                                                </span>

                                                            </div>

                                                        ))
                                                    }

                                                </div>

                                            </div>

                                        </div>

                                    </AnimateOnView>
                                )
                            })
                        }
                    </div>

            </div>
        </section>
    )
}

Projects.propTypes = {
    projects: PropTypes.arrayOf(
        PropTypes.shape({
            descriptionKey: PropTypes.string.isRequired,
            img: PropTypes.number.isRequired,
            link: PropTypes.string.isRequired,
            titleKey: PropTypes.string.isRequired,
            tools: PropTypes.arrayOf(PropTypes.string).isRequired,
        })
    ),
};

Projects.defaultProps = {
    projects: [],
};


